/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationExclusionRulesListRequest {
    getFixupPrototypeFunction() { return RecommendationExclusionRulesListRequest.fixupPrototype; }

    static newInstance(model: Partial<RecommendationExclusionRulesListRequest>): RecommendationExclusionRulesListRequest {
        let obj = Object.assign(new RecommendationExclusionRulesListRequest(), model);
        RecommendationExclusionRulesListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationExclusionRulesListRequest>): RecommendationExclusionRulesListRequest {
        if (!model) return null;
        return RecommendationExclusionRulesListRequest.newInstance(<RecommendationExclusionRulesListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationExclusionRulesListRequest) {
        if (!obj) return;

        models.RecommendationExclusionRulesListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationExclusionRulesListRequest): boolean {
        Object.setPrototypeOf(obj, RecommendationExclusionRulesListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.RecommendationExclusionRuleFilters.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.RecommendationExclusionRulesSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.RecommendationExclusionRulesSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.RecommendationExclusionRuleFilters;

}
